// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Go-z","badgeLink":"Ho-z","category":"Io-z"};